import model from '../../../../common/assets/model3d/CEPR_GLB_NOLOGO.glb'
import {useRef, /*useState*/} from 'react';
import {useGLTF} from '@react-three/drei';
import {PerspectiveCamera} from '@react-three/drei';


export const CeprItem = () => {
    const group = useRef()
    const {nodes} = useGLTF(model)
    return (
        <>
            <group ref={group} dispose={null}>
                <group scale={1} position={[0, -1000, 0]}>
                    <group position={[16.04, -0.05, -74.98]} rotation={[-Math.PI / 2, 0, 0]}>
                        <mesh geometry={nodes.RENDER_VIDEO_1.geometry} material={nodes.RENDER_VIDEO_1.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_2.geometry} material={nodes.RENDER_VIDEO_2.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_3.geometry} material={nodes.RENDER_VIDEO_3.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_4.geometry} material={nodes.RENDER_VIDEO_4.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_5.geometry} material={nodes.RENDER_VIDEO_5.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_6.geometry} material={nodes.RENDER_VIDEO_6.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_7.geometry} material={nodes.RENDER_VIDEO_7.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_8.geometry} material={nodes.RENDER_VIDEO_8.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_9.geometry} material={nodes.RENDER_VIDEO_9.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_10.geometry} material={nodes.RENDER_VIDEO_10.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_11.geometry} material={nodes.RENDER_VIDEO_11.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_12.geometry} material={nodes.RENDER_VIDEO_12.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_13.geometry} material={nodes.RENDER_VIDEO_13.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_14.geometry} material={nodes.RENDER_VIDEO_14.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_15.geometry} material={nodes.RENDER_VIDEO_15.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_16.geometry} material={nodes.RENDER_VIDEO_16.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_17.geometry} material={nodes.RENDER_VIDEO_17.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_18.geometry} material={nodes.RENDER_VIDEO_18.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_19.geometry} material={nodes.RENDER_VIDEO_19.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_20.geometry} material={nodes.RENDER_VIDEO_20.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_21.geometry} material={nodes.RENDER_VIDEO_21.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_22.geometry} material={nodes.RENDER_VIDEO_22.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_23.geometry} material={nodes.RENDER_VIDEO_23.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_24.geometry} material={nodes.RENDER_VIDEO_24.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_25.geometry} material={nodes.RENDER_VIDEO_25.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_26.geometry} material={nodes.RENDER_VIDEO_26.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_27.geometry} material={nodes.RENDER_VIDEO_27.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_28.geometry} material={nodes.RENDER_VIDEO_28.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_29.geometry} material={nodes.RENDER_VIDEO_29.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_30.geometry} material={nodes.RENDER_VIDEO_30.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_31.geometry} material={nodes.RENDER_VIDEO_31.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_32.geometry} material={nodes.RENDER_VIDEO_32.material}/>

                        {/* <mesh geometry={nodes.RENDER_VIDEO_33.geometry} material={nodes.RENDER_VIDEO_33.material}  rotation={open?[0,0,-1]:[0,0,0]} position={open?[700,0,0]:[0,0,0]} onClick={()=>setOpen(!open)}/>
              <mesh geometry={nodes.RENDER_VIDEO_34.geometry} material={nodes.RENDER_VIDEO_34.material}   rotation={open?[0,0,-1]:[0,0,0]} position={open?[700,0,0]:[0,0,0]} onClick={()=>setOpen(!open)}/>
              <mesh geometry={nodes.RENDER_VIDEO_35.geometry} material={nodes.RENDER_VIDEO_35.material}   rotation={open?[0,0,-1]:[0,0,0]} position={open?[700,0,0]:[0,0,0]} onClick={()=>setOpen(!open)}/>
              <mesh geometry={nodes.RENDER_VIDEO_36.geometry} material={nodes.RENDER_VIDEO_36.material}   rotation={open?[0,0,-1]:[0,0,0]} position={open?[700,0,0]:[0,0,0]}  onClick={()=>setOpen(!open)}/>
              <mesh geometry={nodes.RENDER_VIDEO_37.geometry} material={nodes.RENDER_VIDEO_37.material}   rotation={open?[0,0,-1]:[0,0,0]} position={open?[700,0,0]:[0,0,0]} onClick={()=>setOpen(!open)}/> */}

                        <mesh geometry={nodes.RENDER_VIDEO_33.geometry} material={nodes.RENDER_VIDEO_33.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_34.geometry} material={nodes.RENDER_VIDEO_34.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_35.geometry} material={nodes.RENDER_VIDEO_35.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_36.geometry} material={nodes.RENDER_VIDEO_36.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_37.geometry} material={nodes.RENDER_VIDEO_37.material}/>

                        <mesh geometry={nodes.RENDER_VIDEO_38.geometry} material={nodes.RENDER_VIDEO_38.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_39.geometry} material={nodes.RENDER_VIDEO_39.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_40.geometry} material={nodes.RENDER_VIDEO_40.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_41.geometry} material={nodes.RENDER_VIDEO_41.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_42.geometry} material={nodes.RENDER_VIDEO_42.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_43.geometry} material={nodes.RENDER_VIDEO_43.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_44.geometry} material={nodes.RENDER_VIDEO_44.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_45.geometry} material={nodes.RENDER_VIDEO_45.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_46.geometry} material={nodes.RENDER_VIDEO_46.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_47.geometry} material={nodes.RENDER_VIDEO_47.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_48.geometry} material={nodes.RENDER_VIDEO_48.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_49.geometry} material={nodes.RENDER_VIDEO_49.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_50.geometry} material={nodes.RENDER_VIDEO_50.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_51.geometry} material={nodes.RENDER_VIDEO_51.material}/>
                        <mesh geometry={nodes.RENDER_VIDEO_52.geometry} material={nodes.RENDER_VIDEO_52.material}/>
                        <mesh
                            geometry={nodes['RENDER_VIDEO_#1'].geometry}
                            material={nodes['RENDER_VIDEO_#1'].material}
                            position={[0, -1164.05, 0]}
                        />
                    </group>
                </group>
                <PerspectiveCamera
                    makeDefault={true}
                    far={8000.65}
                    near={100.94}
                    fov={50}
                    position={[2803.31, 1511.26, 1239.59]}
                    rotation={[-0.46, 1.0, 0.44]}
                />
                {/* <PerspectiveCamera
            makeDefault={false}
            far={6648.98}
            near={5182.08}
            fov={39.6}
            position={[5399.96, 1538.09, -2348.44]}
            rotation={[-2.9, 1.13, 2.92]}
          />
          <PerspectiveCamera
            makeDefault={false}
            far={6765.61}
            near={4971.65}
            fov={39.6}
            position={[4683.99, 2291.65, -3276.86]}
            rotation={[-2.76, 0.92, 2.83]}
          /> */}
                {/* <PerspectiveCamera
            makeDefault={true}
            far={003.74}
            near={506.49}
            fov={65.47}
            position={[1855.97, 1119.29, 3215.14]}
            rotation={[-0.06, 0.54, 0.03]}
          />
          <PerspectiveCamera
            makeDefault={false}
            far={6758.49}
            near={5044.75}
            fov={39.6}
            position={[2424.45, 1753.51, 5322.45]}
            rotation={[-0.15, 0.42, 0.06]}
          /> */}
                {/* <PerspectiveCamera
            makeDefault={false}
            far={6758.49}
            near={5044.75}
            fov={39.6}
            position={[2424.45, 1753.51, 5322.45]}
            rotation={[-0.15, 0.42, 0.06]}
          /> */}
            </group>
            {/* <mesh geometry={nodes.robot.geometry}>
        <meshStandardMaterial color="#ff0000" transparent opacity={0.5} />
      </mesh> */}
            {/* //  <primitive transparent object = {gtfl.scene } position={[0, -1, 0]}/> */}
        </>
    );
}
//  useGLTF.preload(model)